import { createActivityModalExecutor } from '@organisms/actions/createActivityModalExecutor';
import { getActivityIdFromCompositeId } from '@utils/helpers';
import { IRollbackDelegateProps } from './IRollbackDelegateProps';
import { RollbackDelegateModal } from './RollbackDelegateModal';

export const RollbackDelegateExecutor = createActivityModalExecutor<IRollbackDelegateProps>({
    modal: RollbackDelegateModal,
    defaultModalSize: 'l',
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        activityId: getActivityIdFromCompositeId(objId),
        actionKey: action.key,
        title: action.options?.title ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
